import { useState } from "react";
import { ShieldOff, Clock, RefreshCw } from "lucide-react";
import { Assessments } from "@/lib/api";
import { toast } from "sonner";

const OPTIONS = [
  { v: "7", label: "7 dias" }, { v: "30", label: "30 dias" },
  { v: "90", label: "90 dias" }, { v: "none", label: "Sem data de expiração" },
];
const fmt = (iso) => new Date(iso).toLocaleDateString("pt-PT", { day: "2-digit", month: "2-digit", year: "numeric" });

export default function ShareLinkControls({ assessmentId, info, onChange }) {
  const [days, setDays] = useState("7");
  const [busy, setBusy] = useState(false);
  const active = info.state === "active";

  const run = async (fn, okMsg) => {
    setBusy(true);
    try { await onChange(await fn()); toast.success(okMsg); }
    catch { toast.error("Não foi possível atualizar o link"); }
    finally { setBusy(false); }
  };
  const apply = () => {
    if (days === "none" && !window.confirm("Criar um link SEM data de expiração? O paciente (ou quem tiver o link) poderá abrir o relatório indefinidamente até o revogar.")) return;
    run(() => Assessments.setShare(assessmentId, days === "none" ? null : Number(days)),
    active ? "Validade atualizada" : "Novo link gerado");
  };
  const revoke = () => {
    if (!window.confirm("Revogar este link? O paciente deixará de conseguir abrir o relatório.")) return;
    run(() => Assessments.revokeShare(assessmentId), "Link revogado");
  };

  return (
    <div className="rounded-xl border border-slate-800 bg-slate-900/60 p-3 space-y-3" data-testid="share-controls">
      <div className="flex items-center gap-2 text-xs" data-testid="share-state">
        {active ? <Clock className="w-3.5 h-3.5 text-emerald-400" /> : <ShieldOff className="w-3.5 h-3.5 text-rose-400" />}
        <span className={active ? "text-slate-300" : "text-rose-300"}>
          {info.state === "revoked" ? "Link revogado — o paciente já não tem acesso."
            : info.state === "expired" ? "Link expirado — o paciente já não tem acesso."
            : info.expires_at ? `Válido até ${fmt(info.expires_at)}` : "Válido sem data de expiração"}
        </span>
      </div>
      <div className="flex flex-wrap gap-2">
        <select data-testid="share-validity-select" value={days} onChange={(e) => setDays(e.target.value)} disabled={busy}
          className="flex-1 min-w-[140px] rounded-full bg-slate-950 border border-slate-700 text-slate-200 text-xs px-3 py-2">
          {OPTIONS.map((o) => <option key={o.v} value={o.v}>{o.label}</option>)}
        </select>
        <button data-testid="share-apply-btn" onClick={apply} disabled={busy}
          className="inline-flex items-center gap-1.5 rounded-full border border-slate-700 hover:border-sky-500/50 text-slate-200 text-xs px-3 py-2 transition-colors disabled:opacity-60">
          <RefreshCw className="w-3.5 h-3.5" /> {active ? "Aplicar validade" : "Gerar novo link"}
        </button>
        {active && (
          <button data-testid="share-revoke-btn" onClick={revoke} disabled={busy}
            className="inline-flex items-center gap-1.5 rounded-full border border-rose-500/40 hover:bg-rose-500/10 text-rose-300 text-xs px-3 py-2 transition-colors disabled:opacity-60">
            <ShieldOff className="w-3.5 h-3.5" /> Revogar
          </button>
        )}
      </div>
    </div>
  );
}
